import Button from "components/lib/Shared/Button";
import Input from "components/lib/Shared/Input";
import { Field, Formik, Form } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { updateSubscriptionState } from "state/slices/subscription";
import { Constants } from "config/constants";
import { BadgeCheckIcon } from "@heroicons/react/outline";

const ManageSubsription = () => {
  const dispatch = useDispatch();
  const { selectedSubscription } = useSelector(
    (state) => state.subscriptionSlice
  );

  const getSubscriptionDescription = (name) => {
    if (name === Constants.SUBSCRIPTION_NAMES.BASIC) {
      return "Essential features for small teams";
    } else if (name === Constants.SUBSCRIPTION_NAMES.PRINT) {
      return "Advanced printing and document management";
    } else if (name === Constants.SUBSCRIPTION_NAMES.PREMIUM) {
      return "Complete solution for enterprise needs";
    }
    return "No description available";
  };

  const handleExitWorkflow = () => {
    dispatch(
      updateSubscriptionState({
        selectedSubscription: {
          features: [],
          currencies: [],
        },
        mode: "",
      })
    );
  };

  const handleSubmit = (values) => {
    handleExitWorkflow();
  };

  return (
    <div>
      <div>
        <h2 className="font-bold text-primary">Subscription Plan Settings</h2>
        <p className="text-sm text-gray-600">
          Manage global subscription settings and view detailed reports
        </p>
      </div>
      <div className="mt-4 p2 grid sm:grid-cols-1 md:grid-cols-7">
        {/** Subscription card */}
        <div
          key={selectedSubscription._id}
          className="border rounded-xl rounded-r-none mb-4 shadow-sm hover:shadow-md transition relative bg-white flex flex-col justify-between gap-6 col-span-2 h-full"
        >
          <div className="p-6 flex flex-col justify-between gap-6">
            <div>
              <p className="text-primary font-bold pb-1">
                {selectedSubscription.name}
              </p>
              <p className="text-sm text-gray-500">
                {getSubscriptionDescription(selectedSubscription.name)}
              </p>
            </div>
            <div>
              {selectedSubscription.currencies.length > 0 ? (
                <>
                  <p className="text-primary pb-1">
                    <span className="text-2xl font-bold">
                      {selectedSubscription.currencies[0].type}{" "}
                      {selectedSubscription.currencies[0].basePrice}
                    </span>
                    <span className="text-gray-500 text-sm"> /month</span>
                  </p>
                  <p className="text-gray-500 text-sm">Base price per tenant</p>
                </>
              ) : (
                <>
                  <p className="text-primary">
                    <span className="text-2xl font-bold">KES 0</span>
                    <span className="text-gray-500 text-sm"> /month</span>
                  </p>
                  <p className="text-gray-500 text-sm">Base price per tenant</p>
                </>
              )}
            </div>
            {/** Features */}
            <div>
              {selectedSubscription?.features?.length > 0 && (
                <ul className="list-none py-4 space-y-2">
                  {selectedSubscription.features.map((feature) => {
                    return (
                      <li
                        key={feature._id}
                        className="text-sm list-none text-gray-600"
                      >
                        <div className="flex gap-1 items-center">
                          <BadgeCheckIcon className="w-4 h-4 text-green-900" />
                          <span>{feature.description}</span>
                        </div>
                      </li>
                    );
                  })}
                  {selectedSubscription?.subscribersLimit && (
                    <li key="subscribers-limit" className="text-sm list-none">
                      <div className="flex gap-1 items-center text-gray-600">
                        <BadgeCheckIcon className="w-4 h-4 text-green-900" />
                        <span>
                          {`Up to ${selectedSubscription.subscribersLimit} seats`}
                        </span>
                      </div>
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="col-span-5 border rounded-xl rounded-l-none p-4 h-full shadow-sm hover:shadow-md transition relative bg-white ">
          <Formik
            enableReinitialize
            initialValues={{
              ...selectedSubscription,
              basePrice: selectedSubscription?.currencies[0]?.basePrice || 0,
            }}
            onSubmit={(values) => handleSubmit(values)}
          >
            <Form className="flex flex-col justify-between gap-6">
              <div>
                <h1 className="font-semibold text-primary">
                  Manage {selectedSubscription.name} plan
                </h1>
              </div>
              <Field
                component={Input}
                name="description"
                type="text"
                placeholder="List your offer"
                label="Description"
              />
              <div className="grid grid-cols-4 gap-2">
                <Field
                  component={Input}
                  name="basePrice"
                  type="text"
                  placeholder="Base Price (KES)"
                  label="Base Price (KES)"
                  className="col-span-2"
                />
                <Field
                  component={Input}
                  name="subscribersLimit"
                  type="text"
                  placeholder="Max seats"
                  label="Max seats"
                  className="col-span-2"
                />
              </div>
              <div className="float-right flex justify-end gap-4">
                <Button
                  className="bg-white text-primary border-gray-300"
                  onClick={handleExitWorkflow}
                >
                  Cancel
                </Button>
                <Button className="bg-primary text-white" type="submit">
                  Save & Proceed
                </Button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ManageSubsription;
